(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group-carousel"] && !Shopify.designMode) return;
  try {
    class GroupCarousel {
    constructor(element) {
      this.carousel = element;
      this.track = this.carousel.querySelector('.group-carousel__track');
      this.slides = Array.from(this.track.children);
      this.prevButton = this.carousel.parentElement.querySelector('.group-carousel__arrow--prev');
      this.nextButton = this.carousel.parentElement.querySelector('.group-carousel__arrow--next');
      this.dotsContainer = this.carousel.parentElement.querySelector('.group-carousel__dots');
      
      this.slidesDesktop = parseInt(this.carousel.dataset.slidesDesktop) || 3;
      this.slidesMobile = parseInt(this.carousel.dataset.slidesMobile) || 1;
      this.autoplay = this.carousel.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.carousel.dataset.autoplaySpeed) || 5000;
      this.showArrows = this.carousel.dataset.showArrows === 'true';
      this.showDots = this.carousel.dataset.showDots === 'true';
      
      this.currentIndex = 0;
      this.autoplayTimer = null;
      
      this.init();
    }
    
    init() {
      if (this.slides.length === 0) return;
      
      this.updateSlidesPerView();
      this.createDots();
      this.bindEvents();
      this.updateCarousel();
      
      if (this.autoplay) {
        this.startAutoplay();
      }
    }
    
    updateSlidesPerView() {
      const isMobile = window.innerWidth <= 768;
      this.slidesPerView = isMobile ? this.slidesMobile : this.slides.length;
      this.maxIndex = isMobile ? Math.max(0, this.slides.length - this.slidesPerView) : 0;
      
      // Update CSS custom properties
      this.carousel.style.setProperty('--slides-desktop', this.slidesDesktop);
      this.carousel.style.setProperty('--slides-mobile', this.slidesMobile);
      
      // Reset carousel position on desktop
      if (!isMobile) {
        this.currentIndex = 0;
      }
    }
    
    createDots() {
      if (!this.showDots || !this.dotsContainer) return;
      
      const isMobile = window.innerWidth <= 768;
      this.dotsContainer.innerHTML = '';
      
      if (isMobile) {
        const totalDots = this.maxIndex + 1;
        
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'group-carousel__dot';
          dot.setAttribute('aria-label', `Ir para slide ${i + 1}`);
          dot.addEventListener('click', () => this.goToSlide(i));
          this.dotsContainer.appendChild(dot);
        }
      }
    }
    
    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }
      
      window.addEventListener('resize', () => {
        this.updateSlidesPerView();
        this.createDots();
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
        this.updateCarousel();
      });
      
      // Pause autoplay on hover (only on mobile)
      if (this.autoplay) {
        this.carousel.addEventListener('mouseenter', () => {
          if (window.innerWidth <= 768) this.stopAutoplay();
        });
        this.carousel.addEventListener('mouseleave', () => {
          if (window.innerWidth <= 768) this.startAutoplay();
        });
      }
    }
    
    updateCarousel() {
      const isMobile = window.innerWidth <= 768;
      
      if (isMobile) {
        const translateX = -(this.currentIndex * (100 / this.slidesPerView));
        this.track.style.transform = `translateX(${translateX}%)`;
      } else {
        this.track.style.transform = 'translateX(0%)';
      }
      
      // Update dots (only on mobile)
      if (this.dotsContainer) {
        const dots = this.dotsContainer.querySelectorAll('.group-carousel__dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('group-carousel__dot--active', index === this.currentIndex);
        });
      }
      
      // Update arrows (only on mobile)
      if (this.prevButton) {
        this.prevButton.style.display = (isMobile && this.currentIndex === 0) ? 'none' : (isMobile ? 'flex' : 'none');
      }
      
      if (this.nextButton) {
        this.nextButton.style.display = (isMobile && this.currentIndex >= this.maxIndex) ? 'none' : (isMobile ? 'flex' : 'none');
      }
    }
    
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateCarousel();
      }
    }
    
    nextSlide() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }
    
    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.updateCarousel();
    }
    
    startAutoplay() {
      if (!this.autoplay || window.innerWidth > 768) return;
      
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        if (this.currentIndex >= this.maxIndex) {
          this.currentIndex = 0;
        } else {
          this.currentIndex++;
        }
        this.updateCarousel();
      }, this.autoplaySpeed);
    }
    
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }
  
  // Initialize all group carousels
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.group-carousel');
    carousels.forEach(carousel => new GroupCarousel(carousel));
  });
  
  // Reinitialize on theme editor changes
  document.addEventListener('shopify:section:load', () => {
    const carousels = document.querySelectorAll('.group-carousel');
    carousels.forEach(carousel => new GroupCarousel(carousel));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-carrossel"] && !Shopify.designMode) return;
  try {
    class ImageCarousel {
    constructor(element) {
      this.carousel = element;
      this.track = this.carousel.querySelector('.image-carousel__track');
      this.slides = Array.from(this.track.children);
      this.prevButton = this.carousel.parentElement.querySelector('.image-carousel__arrow--prev');
      this.nextButton = this.carousel.parentElement.querySelector('.image-carousel__arrow--next');
      this.dotsContainer = this.carousel.parentElement.querySelector('.image-carousel__dots');
      
      this.slidesMobile = parseInt(this.carousel.dataset.slidesMobile) || 1;
      this.showArrows = this.carousel.dataset.showArrows === 'true';
      this.showDots = this.carousel.dataset.showDots === 'true';
      
      this.currentIndex = 0;
      
      this.init();
    }
    
    init() {
      if (this.slides.length === 0) return;
      
      this.updateSlidesPerView();
      this.createDots();
      this.bindEvents();
      this.updateCarousel();
    }
    
    updateSlidesPerView() {
      const isMobile = window.innerWidth <= 768;
      this.slidesPerView = isMobile ? this.slidesMobile : this.slides.length;
      this.maxIndex = isMobile ? Math.max(0, this.slides.length - this.slidesPerView) : 0;
      
      // Reset carousel position on desktop
      if (!isMobile) {
        this.currentIndex = 0;
      }
    }
    
    createDots() {
      if (!this.showDots || !this.dotsContainer) return;
      
      const isMobile = window.innerWidth <= 768;
      this.dotsContainer.innerHTML = '';
      
      if (isMobile) {
        const totalDots = this.maxIndex + 1;
        
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'image-carousel__dot';
          dot.setAttribute('aria-label', `Ir para slide ${i + 1}`);
          dot.addEventListener('click', () => this.goToSlide(i));
          this.dotsContainer.appendChild(dot);
        }
      }
    }
    
    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }
      
      window.addEventListener('resize', () => {
        this.updateSlidesPerView();
        this.createDots();
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
        this.updateCarousel();
      });
    }
    
    updateCarousel() {
      const isMobile = window.innerWidth <= 768;
      
      if (isMobile) {
        const translateX = -(this.currentIndex * (100 / this.slidesPerView));
        this.track.style.transform = `translateX(${translateX}%)`;
      } else {
        this.track.style.transform = 'translateX(0%)';
      }
      
      // Update dots (only on mobile)
      if (this.dotsContainer) {
        const dots = this.dotsContainer.querySelectorAll('.image-carousel__dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('image-carousel__dot--active', index === this.currentIndex);
        });
      }
      
      // Update arrows (only on mobile)
      if (this.prevButton) {
        this.prevButton.style.display = (isMobile && this.currentIndex === 0) ? 'none' : (isMobile ? 'flex' : 'none');
      }
      
      if (this.nextButton) {
        this.nextButton.style.display = (isMobile && this.currentIndex >= this.maxIndex) ? 'none' : (isMobile ? 'flex' : 'none');
      }
    }
    
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateCarousel();
      }
    }
    
    nextSlide() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }
    
    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.updateCarousel();
    }
  }
  
  // Initialize all image carousels
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.image-carousel');
    carousels.forEach(carousel => new ImageCarousel(carousel));
  });
  
  // Reinitialize on theme editor changes
  document.addEventListener('shopify:section:load', () => {
    const carousels = document.querySelectorAll('.image-carousel');
    carousels.forEach(carousel => new ImageCarousel(carousel));
  });
  } catch(e) { console.error(e); }
})();

})();
